<div class="flex flex-col gap-3">
    <app-filters-checkbox-item
        *ngFor="let filter of projectInvolvedUserFilterItems"
        [title]="filter.value"
        [option]="filter"
        (selectionChange)="onFilterSelectionChanged($event)"
    ></app-filters-checkbox-item>
</div>
